<div class="appointment-container">
  <app-label
    [text]="'Your position in queue:'"
     *ngIf="appointment$ && appointment$ > 0">
  </app-label>
  <div class="status-container" *ngIf="appointment$ && appointment$ > 0">
    <label class="label">{{appointment$}}</label>

    <div>
      <app-button [button]="refreshStatusButton">
      </app-button>
    </div>
  </div>
  <div *ngIf="appointment$ === -3 || appointment$ === -4">
    <span>Appointment was not completed</span>
  </div>
  <div *ngIf="appointment$ === -2">
    <span>Appointment is completed</span>
  </div>
  <div *ngIf="appointment$ === 0">
    <span>You missed this appointment</span>
  </div>
  <div *ngIf="appointment$ === -1">
    <span>Your appointment was cancelled</span>
  </div>
</div>
